import { render, staticRenderFns } from "./FlagIcon.vue?vue&type=template&id=62006b69&"
import script from "./FlagIcon.vue?vue&type=script&lang=ts&"
export * from "./FlagIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports